import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';

import { brandConstants } from 'brand-config';
import { Label } from 'core';
import { FormField } from 'core/components/form';
import { Card } from 'core/components/card';
import { NotificationCard } from 'core/components/notification-card';
import infoIcon from 'core/assets/svg/ic-info-dark.svg';

import useStyles from './changes-for-approval-section.styles';

const DescriptionOfPolicyChanges = ({ variant }) => {
  const classes = useStyles();
  const isFarmPolicyPreview = variant === 'farm';

  return (
    <Card
      type="primary"
      className={clsx(classes.descriptionOfPolicyChangesContainer, {
        [classes.descriptionOfPolicyChangesContainerLight]: isFarmPolicyPreview
      })}
    >
      <Label
        type={isFarmPolicyPreview ? 'greenSmall' : 'darkGreenSmallBold'}
        className={isFarmPolicyPreview ? classes.lightTitle : undefined}
      >
        Speed up processing
      </Label>
      <p className={clsx(classes.pipChangeDescription, { [classes.pipChangeDescriptionLight]: isFarmPolicyPreview })}>
        For fastest service, please provide a detailed description of your policy changes below:
      </p>

      <Grid className={classes.descriptionOfPolicyChangesFormField}>
        <FormField
          mode="light"
          label=""
          placeholder="Description of policy changes (optional)"
          type="textarea"
          id="internalNote"
          name="internalNote"
          rows={4}
          ignoreGlobalDisabledState
        />
      </Grid>

      <NotificationCard
        type="light"
        icon={infoIcon}
        iconSize="icon16"
        className={clsx(classes.infoBox, classes.descriptionOfPolicyChangesInfoBox, {
          [classes.descriptionOfPolicyChangesInfoBoxLight]: isFarmPolicyPreview
        })}
      >
        <Label type="body3" className={classes.infoBoxText}>
          <strong>Important:</strong> Changes will not be applied until approved by the {brandConstants.SHORT_NAME}{' '}
          underwriting processing team. Submitting additional endorsements will cancel this approval request and will
          require you to resubmit your changes.
        </Label>
      </NotificationCard>
    </Card>
  );
};

DescriptionOfPolicyChanges.propTypes = {
  variant: PropTypes.oneOf(['farm', 'miPIP'])
};

DescriptionOfPolicyChanges.defaultProps = {
  variant: 'miPIP'
};

export default DescriptionOfPolicyChanges;
